import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.js';
import './index.css';
import reportWebVitals from './reportWebVitals.js';
import UpdateBanner from './components/UpdateBanner';

function Root() {
  return (
    <React.StrictMode>
      <App />
      <UpdateBanner />
    </React.StrictMode>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<Root />);

reportWebVitals();
